import styled from 'styled-components';

interface IBar {
  width: number;
}

export const Lots = styled.div`
  font-family: 'Roboto';

  .max-height {
    max-height: 620px;
    overflow-y: auto;
  }

  .bd-top {
    border-top: 1px solid #e1e1e1;
  }
  p {
    color: #878787;
    font-size: 14px;
    font-weight: 400;
  }

  .fw-regular {
    font-weight: 500;
  }
`;

export const Bar = styled.div`
  background-color: #ececf4;
  width: 100%;
  height: 4px;
  border-radius: 4px;
  margin-right: 10px;
  margin-top: 8px;
`;

export const Progress = styled.div<IBar>`
  height: 4px;
  border-radius: 4px;
  background-color: #00a3e0;
  width: ${(props) => props.width}%;
  max-width: 100%;
`;
